import React from 'react';
import ShowroomLocatorContent from './ShowroomLocatorContent';

const DesktopShowroomLocator = () => (
  <div className="w-[320px] lg:w-[350px] min-[1440px]:w-[400px] pl-4 pr-4 mt-1">
    <div className="text-gray mb-2 font-bold text-lg">Location</div>
    <div className="text-sm text-gray mb-1">Find your closest showroom</div>
    <ShowroomLocatorContent inputId="showroom-zipcode" />
  </div>
);

DesktopShowroomLocator.propTypes = {};

export default DesktopShowroomLocator;
